import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function fmtDate(iso) {
  try {
    return new Date(iso).toLocaleString("en-US", {
      month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit",
    });
  } catch { return iso || ""; }
}

export default function AdminBookings() {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/admin/bookings`, { withCredentials: true });
        setItems(res.data.items || []);
      } catch (e) { setErr(e?.response?.data?.detail || "Failed to load"); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <section data-testid="admin-bookings">
      <h2 className="font-serif text-3xl md:text-4xl font-light mb-8 tracking-tight">
        Booking requests
      </h2>
      {err && <p className="text-red-600 text-sm mb-4">{err}</p>}
      {loading ? (
        <p className="text-[#0F1F4E]/70">Loading…</p>
      ) : items.length === 0 ? (
        <p className="text-[#0F1F4E]/70">No booking requests yet.</p>
      ) : (
        <div className="overflow-x-auto bg-white border border-[#D9CFA0] rounded-lg">
          <table className="min-w-full text-sm">
            <thead className="bg-[#F2EBD3]">
              <tr className="text-left text-xs uppercase tracking-wider text-[#0F1F4E]/70">
                <th className="px-4 py-3">Received</th>
                <th className="px-4 py-3">Name</th>
                <th className="px-4 py-3">Service</th>
                <th className="px-4 py-3">Date / Time</th>
                <th className="px-4 py-3">Contact</th>
                <th className="px-4 py-3">Notes</th>
                <th className="px-4 py-3">Sent</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id} data-testid={`booking-row-${it.id}`} className="border-t border-[#D9CFA0]/70 align-top">
                  <td className="px-4 py-3 whitespace-nowrap">{fmtDate(it.created_at)}</td>
                  <td className="px-4 py-3">{it.name}</td>
                  <td className="px-4 py-3">{it.service}</td>
                  <td className="px-4 py-3 whitespace-nowrap">{it.preferred_date} · {it.preferred_time}</td>
                  <td className="px-4 py-3">
                    <a href={`mailto:${it.email}`} className="underline">{it.email}</a><br />
                    <a href={`tel:${it.phone}`} className="text-[#0F1F4E]/70">{it.phone}</a>
                  </td>
                  <td className="px-4 py-3 max-w-xs">{it.notes || "—"}</td>
                  <td className="px-4 py-3">{it.email_forwarded ? "✓" : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
